import api from './api';

const getPublicContent = () => {
  return api.get('/test/all');
};

const getUserBoard = () => {
  return api.get('/test/user');
};

const getModeratorBoard = () => {
  return api.get('/test/mod');
};

const getAdminBoard = () => {
  return api.get('/test/admin');
};

const getEmployments = () => {
  // const emps = api.get("/test/employees");
  // console.log('--- frontend/src/services/user.service.js ---' + emps[0]);
  // return emps;
  return api.get('/test/employees');
};

const getEmploymentsWithPw = () => {
  // const emps = api.get("/test/employees");
  // console.log('--- frontend/src/services/user.service.js ---' + emps[0]);
  // return emps;
  return api.get('/test/employees-with-pw');
};

const getEmploymentByEmpNo = (empNo) => {
  return api.get(`/test/employee/${empNo}`);
};

const UserService = {
  getPublicContent,
  getUserBoard,
  getModeratorBoard,
  getAdminBoard,
  getEmployments,
  getEmploymentsWithPw,
  getEmploymentByEmpNo,
};

export default UserService;
